type Props = {
  /**
   * The amount of Tasks available on the account, expressed as a
   * decimal percentage of the total Task limit. For example, an account
   * with a Task limit of 100 and a `taskBuffer` of 1.2 would be able to
   * use up to 120 Tasks.
   */
  taskBufferMultiplier: number;
  taskLimit: number;
  tasksUsed: number;
};

export const accountHasReachedTaskLimit = ({
  taskBufferMultiplier,
  taskLimit,
  tasksUsed,
}: Props) => taskLimit * taskBufferMultiplier - tasksUsed <= 0;
